import { FC } from 'react';

export interface DataTableProgressBarRow {
  id: string;
  value: number;
}

interface DataTableProgressBarRowProps {
  colSpan: number;
  progressBars: DataTableProgressBarRow[];
}

export const DataTableProgressBarRow: FC<DataTableProgressBarRowProps> = ({ colSpan, progressBars }) => {
  if (!progressBars?.length) return null;

  return (
    <tr>
      <td colSpan={colSpan}>
        {progressBars.map(({ id, value }) => (
          <div key={id} className="bg-fletchers-gray-50 h-0.5 w-full rounded">
            <div
              className="bg-fletchers-green-500 h-full rounded transition-all duration-300"
              style={{
                width: `${value}%`,
              }}
            />
          </div>
        ))}
      </td>
    </tr>
  );
};
